import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ICurrency } from '../../../../shared/models';
import { UtilService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-currency-dropdown',
  templateUrl: './currency-dropdown.component.html',
  styleUrls: ['./currency-dropdown.component.scss']
})
export class CurrencyDropdownComponent implements OnInit, OnChanges {

  @Input() currencies;
  @Input() selectedCurrency;
  @Output() userSelectionCurrency: EventEmitter<ICurrency> = new EventEmitter();
  public supportedCurrencies: ICurrency[];
  currency;
  currencySymbol;
  isMobile;
  constructor(
    public utilService: UtilService,
    public variablesService: VariablesService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService?.isMobile();
    this.setCurrencies();
  }
  ngOnChanges() {
    if (this.selectedCurrency) {
      const data = this.utilService.getCurrencyIcon(this.selectedCurrency);
      this.currency = data?.currency;
      this.currencySymbol = data.symbol;
    }
  }

  setCurrencies() {
    this.supportedCurrencies = [];
    for (const val of this.currencies || []) {
      this.supportedCurrencies.push(this.utilService.getCurrencyIcon(val));
    }
  }

  /**Set currency onload */
  setCurrency(code) {
    for (const item of this.currencies) {
      if (code === item.code) {
        this.currency = item?.currency;
        this.currencySymbol = item.symbol;
        break;
      }
    }
    if (!this.currencySymbol) {
      this.currencySymbol = '&#36;';
    }
  }
  /**Set currencySymbol from menu */
  setCurrencyFromMenu(item, name?) {
    // if (name === 'select') {
    //   item = this.supportedCurrencies[item.target.selectedIndex];
    // }
    this.currency = item.currency;
    this.currencySymbol = item.symbol;
    this.userSelectionCurrency.emit(item);
  }

}
